import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import {
  GET_SETTINGS,
  UPDATE_SETTING_STATUS,
  DELETE_SETTING,
  ADD_SETTING,
  EDIT_SETTING,
  UPDATE_SETTINGS_ORDER_STATUS,
} from "../Constants";
import { defaultHeaders } from "../Constants/DefaultHeaders";
import { logout } from "../../utils";
import {
  GetSettingsSuccess,
  GetSettingsFailure,
  UpdateSettingStatusSuccess,
  UpdateSettingStatusFailure,
  DeleteSettingSuccess,
  DeleteSettingFailure,
  AddSettingSuccess,
  AddSettingFailure,
  EditSettingSuccess,
  EditSettingFailure,
  UpdateSettingOrderStatusSuccess,
  UpdateSettingOrderStatusFailure,
} from "../Actions/SettingsAction";

function* GetSettingsRequest(actions) {
  try {
    const res = yield axios.get(
      `${process.env.REACT_APP_API_URL}api/admin/services/${actions.payload.module_type}?status=${actions.payload.status}&user_type=${actions.payload.user_type}`,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(GetSettingsSuccess(res.data));
    } else {
      yield put(GetSettingsFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetSettingsFailure(e));
  }
}

function* UpdateSettingStatusRequest(actions) {
  const body = {
    id: actions.payload.id,
    status: actions.payload.status,
  };
  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/change_setting_status`,
      body,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(UpdateSettingStatusSuccess(res.data));
    } else {
      yield put(UpdateSettingStatusFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateSettingStatusFailure(e));
  }
}

function* DeleteSettingRequest(actions) {
  try {
    const res = yield axios.delete(
      `${process.env.REACT_APP_API_URL}api/admin/settings/${actions.payload}`,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(DeleteSettingSuccess(res.data));
    } else {
      yield put(DeleteSettingFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(DeleteSettingFailure(e));
  }
}

function* AddSettingRequest(actions) {
  const body = {};

  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/add_setting`,
      body,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(AddSettingSuccess(res.data));
    } else {
      yield put(AddSettingFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(AddSettingFailure(e));
  }
}

function* EditSettingRequest(actions) {
  const body = {};

  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/edit_setting`,
      body,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(EditSettingSuccess(res.data));
    } else {
      yield put(EditSettingFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(EditSettingFailure(e));
  }
}

function* settingOrderStatusRequest(actions) {
  let services = [];
  actions.payload.map((arr) => {
    services.push(arr);
  });
  const body = {
    services,
  };

  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/change_services_order_number`,
      body,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(UpdateSettingOrderStatusSuccess(res.data));
    } else yield put(UpdateSettingOrderStatusFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateSettingOrderStatusFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(GET_SETTINGS, GetSettingsRequest);
  yield takeLatest(UPDATE_SETTING_STATUS, UpdateSettingStatusRequest);
  yield takeLatest(DELETE_SETTING, DeleteSettingRequest);
  yield takeLatest(ADD_SETTING, AddSettingRequest);
  yield takeLatest(EDIT_SETTING, EditSettingRequest);
  yield takeLatest(UPDATE_SETTINGS_ORDER_STATUS, settingOrderStatusRequest);
}

export default function* SettingsSaga() {
  yield all([actionWatcher()]);
}
